export interface SortingRequest<T = string> {
  /** Порядок сортировки */
  sortDirection?: 'asc' | 'desc';

  /** Поле сортировки */
  sortField?: T;
}
